import styled, { css } from 'styled-components'

export const Container = styled.div`
    position: fixed;
    right: 0;
    top: 0;
    z-index: 999;

    height: 100%;
    width: 768px;
    background: #FFF;
    transform: translateX(100%);
    transition: transform 0.3s ease;

    display: flex;
    flex-direction: column;

    @media (max-width: 830px){
        width: 100%;
    }

    ${props => props.modalFormsIsOpen && css`
        transform: translateX(0);
        box-shadow: rgb(0 0 0 / 46%) 0px 5px 10px;
    `}
`
